import http from './http';
import { listResource } from './listResource';

export async function listEvaluations(options = {}) {
  return listResource('/evaluations', options);
}

/**
 * Obtiene un evaluación por su ID.
 */
export async function getEvaluationById(id) {
  const res = await http.get(`/evaluations/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un evaluación.
 */
export async function updateEvaluation(id, data) {
  const res = await http.put(`/evaluations/${id}`, data);
  return res.data?.data ?? res.data;
}

/**
 * Crear un evaluación.
 */
export async function createEvaluation(data) {
  const res = await http.post(`/evaluations/`, data);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar evaluación
 */
export const updateEvaluationsStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/evaluations/${id}/status`, { is_active: isActive });

/**
 * Eliminar evaluación
 */
export const deleteEvaluation = (id) => http.delete(`/evaluations/${id}`);

export async function rateVideo(id, data) {
  const res = await http.put(`/evaluations/${id}/rate`, data);
  return res.data?.data ?? res.data;
}

export async function evaluateVideo(id, data) {
  const res = await http.patch(`/evaluations/${id}/rate`, data);
  return res.data?.data ?? res.data;
}

export async function listProgressCompetitions(options = {}) {
  return listResource('/evaluations/competitions', options);
}

export async function listJudgesCompetitions(id,options = {}) {
  return listResource(`/evaluations/competitions/${id}`, options);
}

export const deleteJudge = (competitionId, judgeId) => http.delete(`/evaluations/judge/${competitionId}/${judgeId}`);
export const alertJudge = (competitionId, judgeId) => http.post(`/evaluations/alert/${competitionId}/${judgeId}`, {});
export const changeJudge = (competitionId, payload = {}) => http.post(`/evaluations/changeJudge/${competitionId}`, payload);